import styled from "styled-components";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const PanicButtonTooltipBox = styled.div`
    display: none;
    background-color: white;
    text-align: center;
    border-radius: 0.3rem;
    padding: 0.5rem;
    cursor: default;
    position: absolute !important;
    z-index: 107;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.2rem;
    color: ${({theme}) => theme.colors.textDark};
    width: 130%;
    line-height: 1.2;
    
    &.${ACTIVE} {
        display: block;
    }

   
    @media ${({theme}) => theme.mediaQuery.hoverNone}{
        padding: 0.5rem 1rem 0.5rem 1rem;
    }
`;
